<template>
    <div class="role-switch">
        <div class="user-portal d-flex" v-if="!isUserCentered">
            <v-btn class="login-btn" @click="open_login">{{ $TL.login }}</v-btn>
            <v-btn class="registered-btn" @click="open_regist">
                {{ $TL.register }}
            </v-btn>
        </div>

        <v-menu
            offset-y
            left
            :nudge-top="-10"
            class="user-center-box"
            attach
            v-else
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="avatar-box v-tooltips"
                    v-bind="attrs"
                    v-on="on"
                    :ripple="false"
                >
                    <div
                        class="avatar-icon"
                        :style="
                            `background-image:url(${userCenteredInfo.avatar ||
                                $P.defaultAvatar})`
                        "
                    ></div>
                    <span class="v-tooltip__content">{{
                        userCenteredInfo.name || userCenteredInfo.username
                    }}</span>
                </v-btn>
            </template>
            <div class="setting-list">
                <v-btn class="set-item-btn" @click="setting_account">
                    <v-icon>mdi-settings</v-icon>
                    {{ $TL.accountSetting }}
                </v-btn>
                <v-btn
                    class="set-item-btn"
                    @click="
                        $route.path !== '/favorites' &&
                            $router.push('/favorites')
                    "
                >
                    <v-icon>mdi-bookmark</v-icon>
                    {{ $TL.myCollection }}
                </v-btn>
                <v-btn class="set-item-btn" @click="logout_user_centered">
                    <v-icon>mdi-exit-to-app</v-icon>
                    {{ $TL.signOut }}
                </v-btn>
            </div>
        </v-menu>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getUserProfile } from "@/api/interface.js";
import { get_storage, uncompileStr } from "@/utils/util.js";
export default {
    name: "role-switch",
    props: {
        role: {
            type: Boolean
        }
    },
    data() {
        return {
            offsetX: "100%",
            isUserCentered: false
        };
    },
    computed: {
        ...mapState("userCentered", ["userCenteredInfo"])
    },
    created() {
        this.login_user_centered();
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapMutations("userCentered", ["updateUserCenteredInfo"]),
        open_login() {
            // loginIn
            this.$store.state.vModal.showType = "loginIn";
        },

        open_regist() {
            this.$store.state.vModal.showType = "regist";
        },
        setting_account() {
            this.$store.state.vModal.showType = "setUpAccount";
        },
        //  判断登录个人中心
        async login_user_centered() {
            let userInfo = get_storage("user_login_sucs");
            if (userInfo) {
                let { data } = await getUserProfile();
                this.updateUserCenteredInfo(data.profile);
                this.isUserCentered = true;
            }
        },

        //  退出个人中心
        logout_user_centered() {
            this.isUserCentered = false;
            localStorage.removeItem("user_login_sucs");
            window.location.href = "/";
        }
    }
};
</script>

<style lang="scss">
#v-header .role-switch {
    .user-portal {
        margin-left: 20px;
        position: relative;
        &::before {
            content: "";
            display: block;
            height: 20px;
            width: 1px;
            background-color: rgba($color-white, 0.62);
            position: absolute;
            left: -16px;
            top: 0;
            bottom: 0;
            margin: auto;
        }

        .login-btn {
            color: $color-white;
            padding: 0 12px;
        }

        .registered-btn {
            margin-left: 8px;
        }
    }

    .user-center-box {
        .v-menu__content {
            background-color: $color-white;
        }
        .v-icon {
            color: #888888;
            font-size: 20px;
            margin-right: 8px;
        }

        .setting-list {
            padding: 10px 0;

            .set-item-btn {
                width: 100%;
                font-size: 14px;
                margin-bottom: 8px;
                padding: {
                    left: 12px;
                    right: 30px;
                }

                &:nth-last-of-type(1) {
                    margin-bottom: 0;
                }
            }
        }
    }

    .avatar-box {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 2px solid rgba($color-white, 0.8);
        margin-left: 24px;

        .v-btn__content,
        .avatar-icon {
            width: 100%;
            height: 100%;
        }

        .avatar-icon {
            border-radius: 50%;
            overflow: hidden;
            background: {
                repeat: no-repeat;
                position: center;
                size: cover;
            }
        }

        .v-tooltip__content {
            max-width: 80px;
        }
    }
}
</style>
